// Single source of truth for a shipment's weight + box size, derived from the
// order's stamped item dimensions (manual_sku_map). Couriers should use this so
// payloads carry the real weight/dimensions instead of defaults.
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0; };

export const getShipmentMetrics = (order = {}) => {
    const items = Array.isArray(order.items) ? order.items : [];
    let weightGrams = 0, maxL = 0, maxB = 0, maxH = 0;
    for (const it of items) {
        const qty = num(it.qty ?? it.quantity ?? 1) || 1;
        const w = num(it.weight_grams ?? it.weightGrams ?? it.weight);
        weightGrams += w * qty;
        maxL = Math.max(maxL, num(it.boxLength ?? it.dimensions?.length_cm ?? it.length_cm));
        maxB = Math.max(maxB, num(it.boxBreadth ?? it.dimensions?.breadth_cm ?? it.breadth_cm));
        maxH = Math.max(maxH, num(it.boxHeight ?? it.dimensions?.height_cm ?? it.height_cm));
    }
    // Fallbacks: order-level shipping/package, then sensible single-parcel defaults.
    if (!weightGrams) {
        weightGrams = num(order.shipping?.weight_grams) || num(order.package?.weight) * 1000 || 0;
    }
    const wg = weightGrams || 500;
    return {
        weightGrams: wg,
        weightKg: +(wg / 1000).toFixed(3),
        boxLength: maxL || 18,
        boxBreadth: maxB || 10,
        boxHeight: maxH || 7,
        hasRealWeight: weightGrams > 0,
    };
};

export default getShipmentMetrics;
